/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} UsdInputs */

const en_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

const es_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

const fr_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

const de_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

const ja_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

const zh_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

const ar_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دولار أمريكي (USD)`)
};

const id_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

const it_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

const ru_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

const pt_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

const ko_usd = /** @type {(inputs: UsdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USD`)
};

/**
* | output |
* | --- |
* | "USD" |
*
* @param {UsdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const usd = /** @type {((inputs?: UsdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<UsdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_usd(inputs)
	if (locale === "es") return es_usd(inputs)
	if (locale === "fr") return fr_usd(inputs)
	if (locale === "de") return de_usd(inputs)
	if (locale === "ja") return ja_usd(inputs)
	if (locale === "zh") return zh_usd(inputs)
	if (locale === "ar") return ar_usd(inputs)
	if (locale === "id") return id_usd(inputs)
	if (locale === "it") return it_usd(inputs)
	if (locale === "ru") return ru_usd(inputs)
	if (locale === "pt") return pt_usd(inputs)
	return ko_usd(inputs)
});